import { gql } from "@apollo/client";

export const GET_PORTAL_USER = gql`
  query PortalUserByUmdId($acctOwnerUmdId: String!) {
    getPortalUserByUmdId(acctOwnerUmdId: $acctOwnerUmdId){
        secUserAccountPk
        accountName
        acctOwnerUmdId
        acctOwnerName
        acctOwnerEmail
        acctOwnerPhone
        accountPurpose
        createdUser
        createdTs
        lastUpdatedUser
        lastUpdatedTs
        status
        accountOwner
        systems {
            systemId
            deqId
        }
        lhds {
            lhdId
            lhdName
        }
        institutions {
            institutionCode
            institutionName
        }
    } getUserAssignmentsRes (umdId: $acctOwnerUmdId){
      moduleCode
      moduleAssigned
      moduleRoute
      roleCode
    }
  }
`;

export const GET_ALL_SYSTEM_INSTITUTION_LHD = gql`
  query {
    getWaterSystemMenu {
      value
      label
    },
    getAllInstitutions {
      label
      value
    },
    getAllLocalHealthDepartments{
       label
       value
    }
  }
`;

export const ADD_NEW_PORTAL_USER = gql`
  mutation AddNewPortalUser($secUserAccountPk: String!, $accountName: String!, $acctOwnerUmdId: String!, $accountPurpose: String!, $createdUser: String!, $lastUpdatedUser: String, $status: String,
                      $systems: [AddSystems], $lhds: [AddLhds], $institutions: [AddInstitutions]) {
    addNewPortalUser(AddPortalUserInput: { secUserAccountPk: $secUserAccountPk, accountName: $accountName, acctOwnerUmdId: $acctOwnerUmdId, accountPurpose: $accountPurpose,
                      createdUser: $createdUser, lastUpdatedUser: $lastUpdatedUser, status: $status, systems: $systems, lhds : $lhds, institutions: $institutions}) {
      secUserAccountPk
      accountName
      acctOwnerUmdId
      acctOwnerName
      acctOwnerEmail
      acctOwnerPhone
      accountPurpose
      createdUser
      createdTs
      lastUpdatedUser
      lastUpdatedTs
      status
      accountOwner
      systems {
        systemId
      }
      lhds {
        lhdId
      }
      institutions {
        institutionCode
      }
    }
  }
`;

export const UPDATE_PORTAL_USER = gql`
  mutation UpdatePortalUser($secUserAccountPk: String!, $accountName: String!, $acctOwnerUmdId: String!, $accountPurpose: String!, $lastUpdatedUser: String, $status: String,
                      $systems: [AddSystems], $lhds: [AddLhds], $institutions: [AddInstitutions]) {
    updatePortalUser(UpdatePortalUserInput: { secUserAccountPk: $secUserAccountPk, accountName: $accountName, acctOwnerUmdId: $acctOwnerUmdId, accountPurpose: $accountPurpose,
                      lastUpdatedUser: $lastUpdatedUser, status: $status, systems: $systems, lhds : $lhds, institutions: $institutions}) {
      secUserAccountPk
      accountName
      acctOwnerUmdId
      accountPurpose
      lastUpdatedUser
      status
      systems {
        systemId
      }
      lhds {
        lhdId
      }
      institutions {
        institutionCode
      }
    }
  }
`;

export const DELETE_PORTAL_USER = gql`
  mutation DeletePortalUser($acctOwnerUmdId: String!) {
    deletePortalUser(DeletePortalUserInput: { acctOwnerUmdId: $acctOwnerUmdId }) {
      acctOwnerUmdId
    }
  }
`;